import React from 'react';
import { Square, Star } from 'lucide-react';
import { useIntl } from 'react-intl';
import { HabitType } from '../../types';
import './CellTypeSelect.scss';

interface Props {
  value: HabitType;
  onChange: (type: HabitType) => void;
}

const CellTypeSelect: React.FC<Props> = ({ value, onChange }) => {
  const { formatMessage: t } = useIntl();
  const selected: HabitType = value === 'rating' ? 'rating' : 'checkbox';

  return (
    <div className="cts-switch" role="radiogroup" aria-label={t({ id: 'monthly.popover.type' })}>
      <button
        type="button"
        role="radio"
        aria-checked={selected === 'checkbox'}
        className={`cts-switch__opt${selected === 'checkbox' ? ' cts-switch__opt--active' : ''}`}
        onClick={() => onChange('checkbox')}
      >
        <Square size={12} />
        <span>{t({ id: 'monthly.popover.typeCheckbox' })}</span>
      </button>
      <button
        type="button"
        role="radio"
        aria-checked={selected === 'rating'}
        className={`cts-switch__opt${selected === 'rating' ? ' cts-switch__opt--active' : ''}`}
        onClick={() => onChange('rating')}
      >
        <Star size={12} />
        <span>{t({ id: 'monthly.popover.typeRating' })}</span>
      </button>
    </div>
  );
};

export default CellTypeSelect;
